export default __webpack_public_path__ + "static/media/AppealExciseTemplate.4146b8da.xlsx";